import {Component, Input, OnInit} from '@angular/core';
import {FieldDefine, FieldType, LanguagesService, SearchType} from '../../../../core';
import {GridFormComponent} from '../grid-form.component';

@Component({
  selector: 'gc-filter-item-condition',
  templateUrl: './filter-item-condition.component.html',
  styleUrls: ['./filter-item-condition.component.css']
})
export class FilterItemConditionComponent implements OnInit {

  constructor(private lang: LanguagesService) { }

  FieldTypeEnum = FieldType;

  public arrayListItems: Array<{ text: string, value: number }> = [
    // { text: '', value: null },
    { text: this.lang.define.lib.include, value: SearchType.In },
    { text: this.lang.define.lib.exclude, value: SearchType.NotIn }
  ];

  public boolListItems: Array<{ text: string, value: number }> = [
    // { text: '', value: null },
    { text: '=', value: SearchType.Equal },
    { text: '<>', value: SearchType.NotEqual }
  ];

  public stringListItems: Array<{ text: string, value: number }> = [
    // { text: '', value: null },
    { text: '=', value: SearchType.Equal },
    { text: '<>', value: SearchType.NotEqual },
    { text: this.lang.define.lib.contains, value: SearchType.Contains },
    { text: this.lang.define.lib.startWith, value: SearchType.StartWith },
    { text: this.lang.define.lib.endWith, value: SearchType.EndWith}
  ];

  public dateListItems: Array<{ text: string, value: number }> = [
    // { text: '', value: null },
    { text: this.lang.define.lib.between, value: SearchType.In },
    { text: this.lang.define.lib.outside, value: SearchType.NotIn }
  ];

  @Input() public field: FieldDefine;
  @Input() public form: GridFormComponent;
  ngOnInit(): void {
  }

}
